export const AUDIT_REFERENCE_TARGETS: Record<
  string,
  { entity: string; fields: string; subjectField?: string }
> = {
  "appdata.subject": { entity: "subject", fields: "id,name" },
  "userdata.user": {
    entity: "user",
    fields: "id,name,subject_id",
    subjectField: "subject_id",
  },
  "userdata.company": {
    entity: "company",
    fields: "id,name,subject_id",
    subjectField: "subject_id",
  },
  "userdata.person": {
    entity: "person",
    fields: "id,subject",
    subjectField: "subject",
  },
  "appdata.team": { entity: "team", fields: "id,name" },
  "appdata.maincategory": { entity: "mainCategory", fields: "id,name" },
  "appdata.buildinginformation": {
    entity: "buildingInformation",
    fields: "id,name",
  },
  "appdata.building": { entity: "building", fields: "id,name" },
  "appdata.department": { entity: "department", fields: "id,name" },
  "appdata.examination": { entity: "examination", fields: "id,name" },
};

export function auditReferenceId(value: unknown): string | undefined {
  return typeof value === "string" &&
    /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(
      value
    )
    ? value.toLowerCase()
    : undefined;
}

export const auditReferenceKey = (model: string, id: string) =>
  `${model}:${id}`;
